import {ChangeDetectionStrategy, Component, NgModule, ViewEncapsulation} from '@angular/core';

/**
 * @ngModule ActionFuncMagnifierMinusSvgModule
 */
@Component({
  selector: 'svg[ivyHermesActionFuncMagnifierMinus]',
  template: '<svg:g class="nc-icon-wrapper" transform="matrix(.8 0 0 .8 2.4 2.4)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3"><svg:path data-color="color-2" fill="none" stroke-miterlimit="10" d="M13 10H7"></svg:path><svg:path fill="none" stroke-miterlimit="10" d="M22 22l-6.344-6.344"></svg:path><svg:circle cx="10" cy="10" r="8" fill="none" stroke-miterlimit="10"></svg:circle></svg:g>',

  styles: [
    ':host { fill: currentColor; stroke: currentColor; }',
      ],

  host: {
    'viewBox': '0 0 24 24',
  },

  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionFuncMagnifierMinusSvgComponent {
}

@NgModule({
  declarations: [
    ActionFuncMagnifierMinusSvgComponent,
  ],
  exports: [
    ActionFuncMagnifierMinusSvgComponent,
  ],
})
export class ActionFuncMagnifierMinusSvgModule {}
